export default "__VITE_ASSET__CMMHnbpX__"